module.exports = __webpack_public_path__ + "static/img/作品101.3524f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品101.png
// module id = Rtv2
// module chunks = 1